import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { DatePipe } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import {
  OrderRequestTimeframe,
  OrderRequestTimeframeEnum,
} from "@models/order";
import { QrCodeModule } from "ng-qrcode";
import { TabsModule } from "primeng/tabs";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { CartService } from "../../services/cart.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { OrderListContainerComponent } from "./order-list-container/order-list-container.component";

@Component({
    selector: "app-my-orders",
    providers: [DatePipe],
    imports: [
    AppLayoutComponent,
    QrCodeModule,
    TabsModule,
    PageHeaderComponent,
    MatButtonToggleModule,
    OrderListContainerComponent
],
    templateUrl: "./my-orders.component.html",
    styleUrl: "./my-orders.component.scss"
})
export class MyOrdersComponent implements OnInit {
  pastOrders$ = this.cartService.getMyOrders("past");

  expiredOrders$ = this.cartService.getMyOrders("expired");

  private readonly breakpointObserver = inject(BreakpointObserver);

  isMobile = false;

  DISPLAY_MOBILE_OPTIONS_ENUM = OrderRequestTimeframeEnum;

  // tipa a propriedade como a union ("future" | "past" | "expired")
  displayMobile: OrderRequestTimeframe =
    this.DISPLAY_MOBILE_OPTIONS_ENUM.FUTURES;

  ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        if (result.matches) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
  }

  constructor(
    private cartService: CartService,
    private localStorageService: LocalStorageService,
  ) {}

  currentUser = JSON.parse(
    this.localStorageService.getItem("current_user") ?? "false",
  );
}
